import styled, { css } from "styled-components"
import { transferFinishedOutline } from "./base"

const TransferContainer = styled.div`
  border: ${props => props.theme.timeline.transfer.borderWidth}px solid
    ${props => props.theme.color.area};
  border-radius: 50%;
  background-color: ${props => props.theme.color.translucidBubble};
  width: ${props => props.theme.timeline.transfer.bubbleSize}px;
  height: ${props => props.theme.timeline.transfer.bubbleSize}px;
  margin-left: -${props => props.theme.timeline.transfer.bubbleSize / 2}px;
  margin-top: -${props => props.theme.timeline.transfer.bubbleSize / 2}px;
  box-shadow: ${props => props.theme.boxShadow}, inset 0 0 0 3px transparent;
  ${props =>
    props.isFinished
      ? css`
          ${transferFinishedOutline}
        `
      : ``}
  transition: ${props => props.theme.transition.long};
`

export default TransferContainer
